import Router, { CMSLocation, LocationChangeCallback, LocationService, PrerenderingLocationChangeCallback } from "@cms/core/lib/router";
import {
    addListenerAnalyticScrollDepth,
    analyticsDataLayer,
    analyticsDataLayerAbTest,
    analyticsDataLayerConsent,
    analyticsDataLayerYT,
    createDataLayerPushTimer
} from "./analytics-data-layer";
import { adobeAnalytics, appendAdobeDataAnalytics } from "./analytics-adobe";
import { getCookieValue, handleListenForGDPRCookieChange } from "@cms/utils/lib/cookie";
import { ServedContentType} from "@cms/api-adapter/lib/content";

// tslint:disable-next-line: max-line-length
export const prerenderingCallback: PrerenderingLocationChangeCallback = (contentType: ServedContentType, currentLocation: CMSLocation): Promise<void> => {
    const {
        nodePath,
        location
    } = currentLocation;

    if (contentType !== ServedContentType.PageNotFound && contentType !== ServedContentType.Redirect) {
        sendPageHeartbeat(currentLocation);
        appendAnalytics(nodePath, location, true);
    }
    return Promise.resolve();
};

// tslint:disable-next-line: max-line-length
export const locationChange: LocationChangeCallback = (replaceContentPromise: Promise<ServedContentType>, targetLocation: CMSLocation): Promise<any> => {
    const {
        nodePath,
        location
    } = targetLocation;

    if (replaceContentPromise) {
        return replaceContentPromise.then((type) => {
            if (type !== ServedContentType.PageNotFound && type !== ServedContentType.Redirect) {
                sendPageHeartbeat(targetLocation);
                appendAnalytics(nodePath, location, false);
                analyticsDataLayerAbTest();
                resetStorageScrollDepth();
            }
        });
    }
    return replaceContentPromise;
};

function appendAnalytics(nodePath: string, location: Location, initial: boolean): void {
    analyticsDataLayerConsent();
    analyticsDataLayerYT();
    appendAdobeDataAnalytics(nodePath, location, initial);
    adobeAnalytics();
    analyticsDataLayer();
    dataLayerPushTimer();
}

// Fire one lightweight "page heartbeat" per counted page view so that prerendered
// and client-rendered (Service Worker) views are both recorded once in the access
// logs. First-party, cookieless, best-effort — it must never affect navigation.
function sendPageHeartbeat(cmsLocation: CMSLocation): void {
    const  { nodePath, location } = cmsLocation;
    try {
        const suffix = !nodePath || nodePath === "/"
            ? "/"
            : (nodePath.charAt(0) === "/" ? nodePath : "/" + nodePath);
        const url = "/_api/core/ping" + suffix;
        const urlWithSearch = url + (location?.search || '');

        fetch(urlWithSearch, { method: "GET", credentials: "omit", cache: "no-store" }).catch(() => undefined);
    } catch (e) {
        // heartbeat is purely best-effort; swallow everything
    }
}

export const isCookieAccepted = (): boolean => {
    return getCookieValue("cookiePolicyGDPR") === "2";
};


export const loadScript = (scriptSrc: string) => {
    var scriptElement = document.createElement('script');
    scriptElement.src = scriptSrc;
    scriptElement.type = 'text/javascript';
    document.querySelector('head').appendChild(scriptElement);
}

const locationService: LocationService = new LocationService();

const dataLayerPushTimer = createDataLayerPushTimer();

const resetStorageScrollDepth = addListenerAnalyticScrollDepth();

handleListenForGDPRCookieChange();

new Router(locationService, locationChange, prerenderingCallback, isCookieAccepted);
